function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg14",
  viewBox: "0 0 123.42 77.48",
  version: "1.1",
  "data-name": "Layer 1"
}, props), /*#__PURE__*/React.createElement("defs", {
  id: "defs4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path8",
  fill: "#fcee23",
  d: "M35.85 10.5h77.43a.41.41 0 01.41.41v55.92a.41.41 0 01-.41.41H35.85a.41.41 0 01-.3-.13l-25.71-28a.41.41 0 010-.56l25.71-28a.41.41 0 01.3-.05z",
  fillOpacity: "1",
  strokeLinejoin: "round",
  stroke: "#231f20",
  strokeWidth: ".82"
}), /*#__PURE__*/React.createElement("text", {
  id: "text10",
  strokeWidth: "1.04",
  fontWeight: "700",
  fontSize: "40.46",
  fontFamily: "Calibri-Bold,Calibri",
  fill: "#fff",
  y: "52.47",
  x: "54.94",
  transform: "scale(.96225 1.0392)"
}, "A"), /*#__PURE__*/React.createElement("path", {
  id: "path12",
  strokeWidth: ".53",
  strokeMiterlimit: "10",
  stroke: "#010101",
  fill: "none",
  d: "M68.48 43.87h-7.25l3.61-11.75zm.22-16a2.11 2.11 0 00-.29-.64 1 1 0 00-.55-.35 4.48 4.48 0 00-1.08-.15H63.3a3.62 3.62 0 00-1 .15 1 1 0 00-.5.34 2.24 2.24 0 00-.28.59l-7.79 24.58a7.31 7.31 0 00-.3 1.2.88.88 0 00.14.69 1 1 0 00.71.31 12.43 12.43 0 001.42.06h1.37a2.82 2.82 0 00.81-.16.86.86 0 00.41-.32 1.83 1.83 0 00.21-.5l1.62-5.41h9.61l1.72 5.56a1.46 1.46 0 00.2.45.77.77 0 00.41.27 3.66 3.66 0 00.86.13h1.57c.65 0 1.15 0 1.52-.05a1.22 1.22 0 00.77-.28.78.78 0 00.16-.67 8.16 8.16 0 00-.3-1.22z"
})));